'use strict';

/**
 * View for empty object lists in a shop
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var template = require('../../templates/partials/list-shop-empty.hbs');

var EmptyShopView = ItemView.extend({
    template: template,

    className: 'empty-hint',
});

module.exports = EmptyShopView;